export const testimonialsData = [
  {
    id: 1,
    name: 'Marie Kabongo',
    location: 'Lubumbashi, Haut-Katanga',
    rating: 5,
    text: 'HMC CLINIC a transformé ma grossesse. Les massages prénataux m\'ont soulagée de mes douleurs dorsales et l\'équipe est d\'une douceur exceptionnelle. Je recommande vivement le programme Maternity Zen à toutes les futures mamans de Lubumbashi.',
    initials: 'MK'
  },
  {
    id: 2,
    name: 'Jean-Pierre Mwamba',
    location: 'Lubumbashi, RDC',
    rating: 5,
    text: 'Le VR Massage est une expérience incroyable que je n\'avais jamais vécue ailleurs en RDC. La technologie combinée au professionnalisme de l\'équipe crée une relaxation totale. C\'est vraiment innovant pour notre région.',
    initials: 'JPM'
  },
  {
    id: 3,
    name: 'Chantal Mukendi',
    location: 'Lubumbashi',
    rating: 5,
    text: 'Après des mois de stress au travail, j\'ai découvert HMC CLINIC. Les séances de soutien psycho-émotionnel m\'ont aidée à retrouver mon équilibre. L\'environnement est apaisant et le personnel très à l\'écoute.',
    initials: 'CM'
  },
  {
    id: 4,
    name: 'Patrick Tshisekedi',
    location: 'Haut-Katanga',
    rating: 5,
    text: 'La massothérapie professionnelle de HMC CLINIC a soulagé mes douleurs chroniques au dos. Les thérapeutes sont hautement qualifiés et l\'approche est vraiment personnalisée. Meilleure clinique de bien-être à Lubumbashi.',
    initials: 'PT'
  },
  {
    id: 5,
    name: 'Grâce Kalala',
    location: 'Lubumbashi, RDC',
    rating: 5,
    text: 'Les conseils nutritionnels ont changé ma vie. J\'ai plus d\'énergie, je dors mieux et j\'ai perdu du poids sainement. L\'équipe de HMC CLINIC est professionnelle et bienveillante. Merci infiniment.',
    initials: 'GK'
  },
  {
    id: 6,
    name: 'Daniel Kasongo',
    location: 'Lubumbashi',
    rating: 5,
    text: 'Notre entreprise a fait appel à HMC CLINIC pour un programme de bien-être au travail. Les résultats sont impressionnants : moins de stress, meilleure ambiance et productivité accrue. Service exceptionnel.',
    initials: 'DK'
  }
];